import { render, staticRenderFns } from "./PropertyOriginSelector.vue?vue&type=template&id=59819408"
import script from "./PropertyOriginSelector.vue?vue&type=script&lang=ts"
export * from "./PropertyOriginSelector.vue?vue&type=script&lang=ts"
import style0 from "./PropertyOriginSelector.vue?vue&type=style&index=0&id=59819408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports